export default [
  {
    name: 'Ekonomia',
    description:
      'Ekonomia, w całej swojej mnogości podejść i nurtów, to moja pasja, która rozwijała się od czasów liceum, gdy brałem udział w olimpiadzie. Ciekawość tego, jak można zarządzać państwem, stała się inspiracją do stworzenia mojej platformy z testami politycznymi Soulgraphy.',
    image: 'kanada',
  },
  {
    name: 'Przyroda i świat zwierząt',
    description:
      'Od najmłodszych lat fascynuje mnie świat zwierząt i środowisko, w którym żyją. Jako dziecko chciałem zostać zoologiem.',
    image: 'seal',
  },
  {
    name: 'Państwa świata',
    description:
      'Z każdym rokiem coraz bardziej fascynuje mnie zgłębianie wiedzy o różnych zakątkach świata. To, jak języki kształtowały się na przestrzeni czasu, pomaga lepiej rozumieć kulturę i sposób myślenia ludzi z różnych krajów. Zagłębiając się w ich historię, łatwiej dostrzec, co wpływa na to, jak wygląda ich teraźniejszość. Szczególnie interesują mnie państwa nordyckie oraz Japonia.',
    image: 'japan',
  },
  {
    name: 'Technologie elektroniczne',
    description:
      'Elektronika, programowanie czy technologie telekomunikacyjne to dla mnie nie tylko ciekawa dziedzina nauki. To przede wszystkim narzędzie, dzięki któremu mogę poczuć się jak wynalazca i samodzielnie tworzyć własne układy elektroniczne czy aplikacje internetowe.',
    image: 'telecommunications',
  },
  {
    name: 'Fizyka i technologia',
    description:
      'Zawsze ciekawiło mnie, jak działa świat. Nieważne, czy chodzi o prąd w żarówce, czy to, dlaczego świeci słońce. Fizyka jest dla mnie procesem poznawania świata i zrozumienia, dlaczego zachowuje się tak, a nie inaczej. Wykorzystanie tej wiedzy daje genialnym umysłom narzędzia do tworzenia innowacyjnych rozwiązań, które zmieniają świat na naszych oczach — od taniej i czystej energetyki, przez wydajne baterie, po leki, które ratują życie.',
    image: 'physics',
  },
  {
    name: 'Gotowanie',
    description:
      'Kocham gotować i eksperymentować w kuchni, a przyrządzanie makaronów czy mięsa jest stałym elementem mojego dnia. Poza kuchnią polską uwielbiam dnia koreańskie i indyjskie.',
    image: 'cooking',
  },
  {
    name: 'Fantasy, gry i relaks',
    description:
      'Nikt o zdrowych zmysłach nie wraca z pracy do kolejnej pracy, bo każdemu potrzebny na relaks i czas na oderwanie się od codzienności. A gdy to robię to zazwyczaj oglądam filmy, zgłębiam (oraz piszę) fantastykę, robię tripy samochodem albo gram w najróżniejsze gry ze znajomymi.',
    image: 'relax',
  },
]
